export const SOUTHLAND_GROUPS = [
    "IDENT",
    "0000001000",
    "0000002000",
    "0000002500",
    "DRLD",
    "DRMW",
    "DRRE",
    "DRRM",
    "DRSA",
    "DRSW",
    "DRTP",
    "SOUTHLAND",
];
